import config from '../../config'

export const appUrls = config
